import { useState } from "react";
import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import logo from "../../assets/kangaroo/logoSmartKampus.png";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import { Formik } from "formik";
import LoginService from "../../services/LoginService";
import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const [email, setemail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);

  const navigate = useNavigate();

  const loginValidationSchema = Yup.object().shape({
    email: Yup.string()
      .min(3, "email must be at least 3 characters")
      .max(50, "email must not exceed 50 characters")
      .required("email is required")
      .trim(),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .max(100, "Password must not exceed 100 characters")
      .required("Password is required"),
  });

  const handleLogin = async (values) => {
    try {
      const response = await LoginService.login({
        email: values.email,
        password: values.password,
        userFrom: 3,
      });

      console.log("response", response);

      // if (
      //   response?.roles[0] === "SuperAdmin" ||
      //   response?.roles[0] === "SmartCampusAdmin" ||
      //   response?.roles[0] === "User"
      // ) {
      localStorage.setItem("user", JSON.stringify(response));

      navigate("/home");
      toast.success("Login successful!");
      // } else {
      //   toast.error("Login with smart campus's email.");
      //   navigate("/login");
      // }
    } catch (error) {
      console.log("Login failed:", error);
      toast.error(
        error?.response?.data || "Something went wrong. Please try again.",
      );
    }
  };

  return (
    <div className="min-vh-100">
      <Row className="min-vh-100 m-0 g-0">
        {/* LEFT SECTION */}
        <Col
          lg={7}
          className="d-none d-lg-flex flex-column justify-content-center align-items-center text-center text-white p-5"
          style={{
            background: "linear-gradient(135deg, #764ba2 0%, #c77dff 100%)",
          }}
        >
          <img
            src={logo}
            alt="Kangaroo Logo"
            className="img-fluid mb-4"
            style={{ maxHeight: "140px" }}
          />

          {/* <div>
            <h1
              className="m-0 p-0 font-level-4  text-uppercase"
              style={{ letterSpacing: "3px", lineHeight: "1" }}
            >
              Start Smart
            </h1>

            <h1
              className="font-level-4 fw-bold text-uppercase mt-0"
              style={{
                letterSpacing: "4px",
                color: "#7E1790",
                lineHeight: "1",
              }}
            >
              With Kangaroo
            </h1>
          </div> */}
          <hr
            className="w-25 my-1"
            style={{
              backgroundColor: "#F6921E",
              height: "3px",
              border: "none",
              opacity: 1
            }}
          />

          <Card className="bg-transparent border-0 w-75">
            <CardBody className="p-4">
              <h3 className="fw-bold mb-3 text-white">
                Where You Start Smart,    Learn Continously, and Deliver with Confidence
              </h3>
              {/* <p className="fs-5 mb-0 text-white">
               Where Structured Information Empowers You To Start Smart and Deliver with Precision.
              </p> */}
            </CardBody>
          </Card>
        </Col>

        {/* RIGHT SECTION */}
        <Col
          xs={12}
          lg={5}
          className="d-flex align-items-center justify-content-center px-3 px-sm-4 px-md-5 py-5 bg-light position-relative order-1 order-lg-2"
        >
          {/* Login Card */}
          <Card
            className="shadow-lg w-100 border-0 rounded-4"
            style={{ maxWidth: "480px" }}
          >
            <CardBody className="p-4 p-md-5">
              {/* Header Section */}
              <div className="text-center mb-4">
                <div
                  className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center shadow"
                  style={{
                    width: "70px",
                    height: "70px",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  }}
                >
                  <i className="bi bi-person-fill text-white fs-2"></i>
                </div>
                <h2 className="fw-bold text-dark mb-2">Welcome Back</h2>
                <p className="text-muted mb-0">Please login to continue</p>
              </div>

              {/* Divider */}
              <hr className="my-4 border-2 opacity-25" />

              {/* Form Section */}
              <Formik
                initialValues={{
                  email: "",
                  password: "",
                }}
                validationSchema={loginValidationSchema}
                onSubmit={async (values, { setSubmitting }) => {
                  try {
                    await handleLogin(values);
                  } catch (error) {
                    console.error("Login error:", error);
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    {/* Email Field */}
                    <FormGroup className="mb-4">
                      <Label
                        for="email"
                        className="fw-semibold text-dark mb-2 d-flex align-items-center gap-2"
                      >
                        <i className="bi bi-envelope text-primary"></i>
                        Username
                      </Label>
                      <Input
                        type="text"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control-lg rounded-3 border-2 shadow-sm"
                        invalid={touched.email && !!errors.email}
                      />
                      {touched.email && errors.email && (
                        <FormFeedback className="ps-2">
                          {errors.email}
                        </FormFeedback>
                      )}
                    </FormGroup>

                    {/* Password Field */}
                    <FormGroup className="mb-4">
                      <Label
                        for="password"
                        className="fw-semibold text-dark mb-2 d-flex align-items-center gap-2"
                      >
                        <i className="bi bi-lock text-primary"></i>
                        Password
                      </Label>

                      <div className="position-relative">
                        <Input
                          type={passwordShow ? "text" : "password"}
                          id="password"
                          name="password"
                          placeholder="Enter your password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="form-control-lg rounded-3 border-2 shadow-sm pe-5"
                          invalid={touched.password && !!errors.password}
                        />

                        {touched.password && errors.password && (
                          <FormFeedback className="ps-2">
                            {errors.password}
                          </FormFeedback>
                        )}

                        {/* Show/Hide Button */}
                        <Button
                          color="link"
                          type="button"
                          className="position-absolute text-decoration-none text-muted p-0 border-0 bg-transparent"
                          style={{
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 10,
                          }}
                          onClick={() => setPasswordShow(!passwordShow)}
                        >
                          {passwordShow ? (
                            <EyeOff size={20} />
                          ) : (
                            <Eye size={20} />
                          )}
                        </Button>
                      </div>
                    </FormGroup>

                    {/* Remember Me Checkbox */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <FormGroup check inline className="mb-0">
                        <Input type="checkbox" id="remember" />
                        <Label
                          check
                          for="remember"
                          className="small text-muted ms-2"
                        >
                          Remember me
                        </Label>
                      </FormGroup>

                      <Link
                        to="/forgot-password"
                        className="small fw-semibold text-decoration-none"
                        style={{ color: "#764ba2" }}
                      >
                        Forgot password?
                      </Link>
                    </div>

                    {/* Submit Button */}
                    <Button
                      type="submit"
                      size="lg"
                      block
                      disabled={isSubmitting}
                      className="w-100 fw-semibold rounded-3 border-0 shadow"
                      style={{
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      }}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Logging in...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-box-arrow-in-right me-2"></i>
                          Login
                        </>
                      )}
                    </Button>

                    <div className="text-center mt-4">
                      <small className="text-muted">
                        Don't have an account?{" "}
                        <Link
                          to="/register"
                          className="fw-bold text-decoration-none"
                          style={{ color: "#764ba2" }}
                        >
                          Register now
                        </Link>
                      </small>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
